// Every form uses the public key from the same Worker that verifies its tokens.
// A production build must never fall back to an old key baked into JavaScript.
export async function loadTurnstileSiteKey(): Promise<string> {
  try {
    const response = await fetch('/api/turnstile-config', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(10000) })
    if (!response.ok) throw new Error('TURNSTILE_CONFIG_UNAVAILABLE')
    const body = await response.json() as { siteKey?: unknown }
    if (typeof body.siteKey !== 'string' || !body.siteKey.trim()) throw new Error('TURNSTILE_CONFIG_INVALID')
    return body.siteKey.trim()
  } catch (error) {
    // Vite alone has no Worker API. This fallback is compiled out of production.
    if (import.meta.env.DEV && import.meta.env.VITE_TURNSTILE_SITE_KEY?.trim()) return import.meta.env.VITE_TURNSTILE_SITE_KEY.trim()
    throw error
  }
}

export function turnstileErrorMessage(code?: string) {
  const safeCode = code && /^\d{6}$/.test(code) ? ` (code ${code})` : ''
  return `Spam protection could not load${safeCode}. Use Retry spam protection, or call 469-756-7680.`
}
